import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "../css/landingPage.css";
import cst from "../images/partnerLogos/cst.png";
import kenli from "../images/partnerLogos/kenli.png";
import kmc from "../images/partnerLogos/kmc.png";
import maxxis from "../images/partnerLogos/maxxis.png";
import wtb from "../images/partnerLogos/wtb.png";
import schwalbe from "../images/partnerLogos/schwalbe.png";
import neco from "../images/partnerLogos/neco.png";
import ralson from "../images/partnerLogos/ralson.png";
import prowheel from "../images/partnerLogos/prowheel.png";
import sunrace from "../images/partnerLogos/sunrace.png";
import shimano from "../images/partnerLogos/shimano.png";
import sram from "../images/partnerLogos/sram.png";
import rockshox from "../images/partnerLogos/rockshox.png";
import microshift from "../images/partnerLogos/microshift.png";
import axios from "axios";
import PhoneInput from "react-phone-number-input";
import Meta from "../components/Meta";
import Modal from "../components/Modal";
import ModalMobile from "../components/ModalMobile";
import ReactPlayer from "react-player";
import CustomBike from "../components/CustomBike";
import "../css/navbar.css";
import logo from "../images/brandLogos/Dynem red white.png";
import { Icon } from "@iconify/react";
import ReCAPTCHA from "react-google-recaptcha";
import "../css/landingPage2.css";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles";

const LandingPage2De = () => {
  const [capVal, setCapVal] = useState("");

  const featuresData = [
    {
      key: "precisionControllers",
      heading: "Präzisions-Controller",
      description:
        "E-Bike-Controller nutzen intelligente Sensoren und Algorithmen für eine gleichmäßige Leistungsabgabe, verbessern die Performance und machen das Fahren intuitiver. Mit DYNEM-Komponenten für intelligente Fahrweise.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Controlerrrr.png",
    },
    {
      key: "highPerformanceChargers",
      heading: "Hochleistungs-Ladegeräte",
      description:
        "Unsere Ladegeräte sind in verschiedenen Ausführungen erhältlich – für weltweite Kompatibilität, einfache Mobilität und flexiblen Energiebedarf. Stärken Sie Ihre Marke mit DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Chargerrrr.png",
    },
    {
      key: "multifunctionalDisplays",
      heading: "Multifunktionales Display",
      description:
        "Multifunktionale LCD-Displays liefern Echtzeit-Statistiken wie Geschwindigkeit und Akkustand und helfen Fahrern, die Kontrolle zu behalten und mühelos zwischen den Modi zu wechseln. Optimieren Sie Ihre Fahrtechnik mit DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Displayyyyy.png",
    },
    {
      key: "longLastingBatteries",
      heading: "Langlebige Akkus",
      description:
        "Unsere langlebigen Akkus sind auf konstante Leistung, lange Lebensdauer und optimale Energieabgabe ausgelegt – für zuverlässige Energieversorgung bei jeder Fahrt. Geben Sie Ihr E-Bike mit DYNEM Energie.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Baterryyyyy.png",
    },
    {
      key: "efficientMotors",
      heading: "Effiziente Motoren",
      description:
        "Unsere effizienten Motoren liefern zuverlässige und präzise Leistung für alle Anwendungen – leistungsstark und zielführend. Fördern Sie Ihre Innovation mit DYNEM.",
      image:
        "https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/motorrrr.png",
    },
  ];
  const [open, openNav] = useState(false);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, []);

  const closeNavforDeadLink = () => {
    openNav(false);
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [enquiry, setEnquiry] = useState("");
  const [sales, setSales] = useState("");
  const [productPortfolio, setProductPortfolio] = useState("");

  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    if (!phoneNumber.trim()) {
      alert("Enter Contact Number");
      return;
    }
    const response = await fetch("/api/verify-captcha", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ capVal }),
    });

    const dataCaptcha = await response.json();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const reqBody = {
      name,
      email,
      phoneNumber,
      companyName,
      enquiry,
      country,
      sales,
      productPortfolio,
    };
    if (dataCaptcha) {
      const { data } = await axios.post(
        "/api/form/request-a-quote",
        reqBody,
        config
      );
      if (data) {
        navigate("/details-submitted");
      }
    } else {
      alert("CAPTCHA Verification Failed!");
    }
  };
  return (
    <>
      <div
        className="position-fixed w-100 d-lg-none"
        style={{ bottom: "1.5%", zIndex: 2 }}
      >
        <div className="d-flex justify-content-center">
          <Link
            to={"/landing-page/form"}
            style={{ width: "85%" }}
            className="btn btn-danger py-2 rounded-5"
          >
            Get in Touch
          </Link>
        </div>
      </div>

      <div id="LandingPage2">
        {/* hero-section */}
        <div className="position-relative">
          <div
            className="position-absolute w-100"
            style={{ top: "2%", zIndex: "1" }}
          >
            <div className="d-lg-block d-none">
              <div className="d-flex justify-content-between align-items-center px-lg-5 mb-5">
                <Link to={"/"}>
                  <img src={logo} alt="dynem-logo" className="logo"></img>
                </Link>
                <Link
                  to={"/"}
                  className="btn btn-danger fw-bold px-4 py-2 rounded-5"
                  style={{ backgroundColor: "#ff0000" }}
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Get in Touch
                </Link>
              </div>
              <div>
                <h3 className="poppins-bold mb-3 text-center text-uppercase text-light">
                  Südostasiens größter E-Bike-Hersteller und -Exporteur
                </h3>
                <h5 className="text-light text-center poppins-medium">
                  Wir gestalten die Zukunft der Mobilität
                </h5>
              </div>
            </div>

            <div className="d-lg-none">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ gap: "2em", flexDirection: "column" }}
              >
                <Link to={"/"}>
                  <img src={logo} alt="dynem-logo" className="logo"></img>
                </Link>
                <div>
                  <h5 className="poppins-bold mb-3 text-center text-uppercase text-light">
                    Südostasiens größter E-Bike-Hersteller und -Exporteur
                  </h5>
                  <p className="text-light text-center poppins-medium">
                    Wir gestalten die Zukunft der Mobilität
                  </p>
                </div>
              </div>
            </div>
          </div>
          <video
            className="w-100"
            autoPlay
            loop
            muted
            playsInline
            style={{ height: "100vh", width: "100vw", objectFit: "cover" }}
          >
            <source
              media="(max-width:650px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Landing+page+video+phone+view+.mp4"
              type="video/mp4"
            />
            <source
              media="(min-width:651px)"
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Landing+Page+video+desktop+view+.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div
            className="position-absolute d-lg-block d-none w-100"
            style={{ bottom: "8%" }}
          >
            <div
              className="w-100 d-flex justify-content-center container px-5"
              style={{ gap: "12em" }}
            >
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">
                  240,000 sq. ft.
                </h4>
                <h5 className="poppins-bold text-light mb-3">Gigafactory</h5>
              </div>
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">500,000</h4>
                <h5 className="poppins-bold text-light mb-3">
                  E-Bikes jährliche Produktionskapazität
                </h5>
              </div>
              <div className="text-center">
                <h4 className="poppins-medium text-light mb-3">18+</h4>
                <h5 className="poppins-bold text-light mb-3">Länder</h5>
              </div>
            </div>
          </div>
          <div
            className="position-absolute d-lg-none text-light"
            style={{ bottom: "13%" }}
          >
            <div
              className="w-100 d-flex justify-content-center container px-3"
              style={{ gap: "0.9em" }}
            >
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  240,000 sq. ft.
                </p>
                <p
                  className="poppins-bold text-light mb-1"
                  style={{ fontSize: "0.6em" }}
                >
                  Gigafactory
                </p>
              </div>
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  500,000
                </p>
                <p
                  className="poppins-bold text-light mb-1 w-75 mx-auto"
                  style={{ fontSize: "0.6em" }}
                >
                  E-Bikes jährliche Produktionskapazität
                </p>
              </div>
              <div className="text-center">
                <p
                  className="poppins-medium text-light mb-1"
                  style={{ fontSize: "0.8em" }}
                >
                  18+
                </p>
                <p
                  className="poppins-bold text-light mb-1"
                  style={{ fontSize: "0.6em" }}
                >
                  Länder
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* form */}
        <div className="d-none d-lg-block my-5 py-lg-5 container">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Lassen Sie uns Ihr nächstes großes Fahrzeug bauen
          </h2>
          <div className="d-flex justify-content-center mb-4">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Nehmen Sie Kontakt mit unserem Geschäftsentwicklung Team auf, um
              herauszufinden, wie DYNEM Ihre E-Cycle-Vision vorantreiben kann.
            </h5>
          </div>
          <div className="row p-0">
            <div className="col-6 p-3">
              <h3 className="poppins-medium mb-4">Warum DYNEM wählen?</h3>
              <div>
                <img
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Group+49.jpg"
                  className="img-fluid"
                ></img>
              </div>
            </div>
            <div className="col-6 p-3">
              <form className="" onSubmit={submit}>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-100">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Name*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                      class="form-control text-dark"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div class="w-50">
                    <label
                      for="exampleInputPassword1"
                      class="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Telefon*
                    </label>
                    <IntlTelInput
                      onChangeNumber={setPhoneNumber}
                      initOptions={{
                        initialCountry: "auto",
                        geoIpLookup: function (success, failure) {
                          fetch("https://ipapi.co/json")
                            .then((res) => res.json())
                            .then((data) => success(data.country_code))
                            .catch(() => failure());
                        },
                        strictMode: true,
                        separateDialCode: true,
                      }}
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      E-mail*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1 text-light"
                      style={{ fontSize: "0.8em" }}
                      className="form-label"
                    >
                      Unternehmen*
                    </label>
                    <input
                      type="text"
                      value={companyName}
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      required
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Product Portfolio*
                    </label>
                    <select
                      onChange={(e) => setProductPortfolio(e.target.value)}
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="E-Bikes">E-Bikes</option>
                      <option value="E-Scooters">E-Scooters</option>
                      <option value="Hyper-Bikes">Hyper-Bikes</option>
                      <option value="Moped">Moped</option>
                    </select>
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Operational Countries*
                    </label>
                    <input
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      type="text"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label"
                      style={{ fontSize: "0.8em" }}
                    >
                      Annual E-Bike Sales (units)
                    </label>
                    <select
                      style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                      onChange={(e) => setSales(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="less than 1000 units">
                        less than 1000 units
                      </option>
                      <option value="1000-5000 units">1000-5000 units</option>
                      <option value="5000-50,000 units">
                        5000-50,000 units
                      </option>
                      <option value="50,000+ units">50,000+ units</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Nachricht*
                  </label>
                  <textarea
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    class="form-control rounded-0"
                    required
                    id="exampleFormControlTextarea1"
                    rows="3"
                    value={enquiry}
                    onChange={(e) => {
                      setEnquiry(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                    onChange={(val) => setCapVal(val)}
                  ></ReCAPTCHA>
                </div>
                <button
                  disabled={!capVal}
                  type="submit"
                  style={{ backgroundColor: "#ff0000" }}
                  class="btn btn-danger w-100 poppins-medium rounded-5 py-2"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
        {/* ebikes */}
        <div className="container mt-5 py-lg-5 ebike-section-landing-page2">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Vom Konzept bis zum Pendeln – Ihr OEM-Partner für jede Phase
          </h2>
          <div className="d-flex justify-content-center">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Ob Sie ein Stadt-Pendlerrad oder ein All-Terrain-Kraftpaket auf
              den Markt bringen – DYNEM verfügt über die Technologie, das Design
              und die Power, um es zu verwirklichen.
            </h5>
          </div>

          <div className="pt-lg-5 pt-4 px-2">
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center text-center"
              options={{
                arrows: true,
                start: 0,
                drag: false,
                type: "loop",
                pagination: true,
                autoplay: true,
                gap: "2em",
                padding: "1em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 1,
                perMove: 1,
                speed: 1000,
                interval: 4000,
                breakpoints: {
                  700: {
                    drag: true,
                    autoplay: false,
                    pagination: "false",
                    perPage: 1,
                    perMove: 1,
                    gap: "2em",
                    padding: "0em",
                    arrows: false,
                    pauseOnHover: false,
                    resetProgress: false,
                  },
                },
              }}
              muted={true}
            >
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Mountain+bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">Mountainbikes</h4>
                    <p className="ecycle-range-car-content text-muted">
                      Wir bauen nicht nur Mountainbikes – wir entwickeln
                      Abenteuer taugliche Maschinen. Unsere Offroad-Modelle sind
                      für raues Gelände konzipiert und bieten unübertroffene
                      Kraft, Kontrolle und Performance. Erlebe die Wildnis mit
                      DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Foldable+Fat+tyre.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">Faltbare Fatbikes</h4>
                    <p className="ecycle-range-car-content text-muted">
                      Kompakt, wenn es drauf ankommt. Robust, wenn es drauf
                      ankommt. Unsere faltbaren Fatbikes sind für den mobilen
                      Alltag gemacht – perfekt für Stadtfahrten, Reisen und
                      Wochenendausflüge. Entdecke deine faltbare Freiheit mit
                      DYNEM.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/City+Bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">City E-Bikes</h4>
                    <p className="ecycle-range-car-content text-muted">
                      Gleiten Sie entspannt durch den Verkehr. Unsere
                      City-E-Bikes vereinen modernste Technologie mit modernem
                      Design und machen das tägliche Pendeln mühelos,
                      komfortabel und stilvoll. Mit DYNEM definieren Sie Ihr
                      urbanes Raderlebnis neu.
                    </p>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100 p-2">
                <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                  <div className="col col-md-6">
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/Delivery+bike.png"
                      alt=""
                      className="w-75"
                    />
                  </div>
                  <div className="text-start col col-md-6 p-lg-3">
                    <h4 className="poppins-medium">Liefer-E-Bikes</h4>
                    <p className="ecycle-range-car-content text-muted">
                      Für mobile Unternehmen. Diese E-Bikes sind für den
                      Schwerlasttransport konzipiert und bieten robuste Rahmen,
                      viel Stauraum und zuverlässige Leistung – und das alles
                      umweltfreundlich. Mit DYNEM sorgen Sie für schnelle,
                      intelligente und nachhaltige Abläufe.
                    </p>
                  </div>
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
        {/* components */}
        <div className="container mt-5 py-lg-5 ebike-section-landing-page2">
          <h2 className="poppins-bold mb-4 text-uppercase text-center">
            Der Antrieb für das Herz jedes E-Bikes
          </h2>
          <div className="d-flex justify-content-center">
            <h5 className="text-center mb-0 col-md-8 text-muted">
              Ob es sich um einen Motor mit hohem Drehmoment oder eine elegante
              Digitalanzeige handelt, DYNEM bietet die Präzision, Leistung und
              Zuverlässigkeit, um Ihre Fahrt mit Qualitätskomponenten
              anzutreiben.
            </h5>
          </div>

          <div className="pt-lg-5 pt-4 px-2">
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center text-center"
              options={{
                arrows: true,
                start: 0,
                drag: false,
                type: "loop",
                pagination: true,
                autoplay: true,
                gap: "2em",
                padding: "1em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 1,
                perMove: 1,
                speed: 1000,
                interval: 4000,
                breakpoints: {
                  700: {
                    drag: true,
                    autoplay: false,
                    pagination: "false",
                    perPage: 1,
                    perMove: 1,
                    gap: "2em",
                    padding: "0em",
                    arrows: false,
                    pauseOnHover: false,
                    resetProgress: false,
                  },
                },
              }}
              muted={true}
            >
              {featuresData.map((feature, index) => (
                <SplideSlide className="h-100 p-2">
                  <div className="p-4 pt-0 p-lg-0 d-flex align-items-center ecycle-range-card">
                    <div className="text-start col col-md-6 p-lg-3 d-lg-block d-none">
                      <h4 className="poppins-medium">{feature.heading}</h4>
                      <p className="ecycle-range-car-content text-muted">
                        {feature.description}
                      </p>
                    </div>
                    <div className="col col-md-6">
                      <img src={feature.image} alt="" className="w-75" />
                    </div>
                    <div className="text-start col col-md-6 p-lg-3 d-lg-none">
                      <h4 className="poppins-medium">{feature.heading}</h4>
                      <p className="component-range-car-content text-muted">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                </SplideSlide>
              ))}
            </Splide>
          </div>
        </div>
        {/* breaker */}
        <div className="mt-5 py-lg-5">
          <picture className="">
            <source
              media="(max-width:650px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/phone+anti+Dumping+banner.png.jpg"
            />
            <source
              media="(min-width:651px)"
              srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/anti+Dumping+banner.png"
            />
            <img
              src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/anti+Dumping+banner.png"
              alt="assurance"
              className="d-block img-fluid"
            />
          </picture>
        </div>
        {/* trust section */}
        <div className="container mt-5 py-4 py-lg-5 trust-section-landing-page2">
          <h2 className="poppins-bold mb-2 text-uppercase text-center">
            Warum globale Marken DYNEM vertrauen
          </h2>
          <h5 className="text-center mb-0 text-muted">
            Ihr Produkt. Unsere Expertise.
          </h5>
          <div className="mt-5 pt-lg-3">
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/end-to-end.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                End-to-End-Fertigungspartner
              </h4>
              <div className="col-md-6">
                <small>
                  Vom Konzept bis zur endgültigen Lieferung bieten wir komplette
                  OEM- und White-Label-Lösungen, die auf die Bedürfnisse Ihrer
                  Marke zugeschnitten sind.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/stae-of-art.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Modernste Fertigung
              </h4>
              <div className="col-md-6">
                <small>
                  Automatisierte Produktionslinien und Präzisionstechnik
                  gewährleisten eine gleichbleibende Fertigungsqualität im
                  großen Maßstab und erfüllen internationale Standards.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/high-performance.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Hochleistungs Technologie
              </h4>
              <div className="col-md-6">
                <small>
                  Wir integrieren leistungsstarke Motoren, Akkus mit großer
                  Reichweite und intelligente IoT-Systeme, um E-Bikes zu
                  entwickeln, die den modernen Mobilitätsanforderungen gerecht
                  werden.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/e-cycles.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Über 500.000 E-Bikes jährlich
              </h4>
              <div className="col-md-6">
                <small>
                  Unsere skalierbare Infrastruktur unterstützt alles – von
                  kleinen Sonderanfertigungen bis hin zur globalen
                  Großserienproduktion – schnell und präzise.
                </small>
              </div>
            </div>
            <div className="mb-5 pb-lg-3">
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/components.jpg"
                className="img-fluid mb-3"
              ></img>
              <h4 className="poppins-medium mb-1 text-uppercase">
                Über 4 Millionen Komponenten pro Jahr
              </h4>
              <div className="col-md-6">
                <small>
                  Durch unsere leistungsstarke Beschaffung und interne
                  Integration gewährleisten wir Verfügbarkeit, Effizienz und
                  Qualität aller Komponenten.
                </small>
              </div>
            </div>
          </div>
        </div>
        {/* company logos */}
        <div className="logos-landing-page2">
          <h3 className="poppins-bold mb-0 text-center text-uppercase">
            Der Name, auf den globale Marken zählen
          </h3>
          <div className="container my-lg-5 pb-5 d-none d-lg-block">
            <Splide
              className="flex align-items-center"
              extensions={{ AutoScroll }}
              options={{
                type: "loop",
                autoScroll: {
                  speed: 1,
                  pauseOnHover: false,
                },
                perPage: 6,
                drag: "free",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                gap: "3em",
                padding: "1em",
                breakpoints: {
                  640: {
                    perPage: 3,
                    gap: "1em",
                  },
                },
              }}
            >
              <SplideSlide className="h-100">
                <div>
                  <img src={shimano} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={kmc} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={maxxis} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={wtb} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={rockshox} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={neco} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={ralson} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sunrace} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={microshift} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sram} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={schwalbe} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
          <div className="my-5 d-lg-none">
            <Splide
              className="flex align-items-center"
              extensions={{ AutoScroll }}
              options={{
                type: "loop",
                autoScroll: {
                  speed: 1,
                  pauseOnHover: false,
                },
                perPage: 6,
                drag: "free",
                arrows: false,
                pagination: false,
                pauseOnHover: false,
                gap: "3em",
                padding: "1em",
                breakpoints: {
                  640: {
                    perPage: 3,
                    gap: "1em",
                  },
                },
              }}
            >
              <SplideSlide className="h-100">
                <div>
                  <img src={shimano} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={kmc} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={maxxis} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={wtb} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={rockshox} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={neco} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={ralson} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sunrace} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={microshift} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={sram} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div>
                  <img src={schwalbe} alt="" className="img-fluid" />
                </div>
              </SplideSlide>
            </Splide>
          </div>
        </div>
        <div className="my-5 py-lg-5 container">
          <Splide
            className="mb-2 mb-lg-0 p-0 align-items-center text-center"
            options={{
              arrows: true,
              start: 0,
              drag: false,
              type: "loop",
              pagination: true,
              autoplay: true,
              gap: "1em",
              padding: "1em",
              pauseOnHover: false,
              resetProgress: false,
              perPage: 3,
              perMove: 1,
              speed: 1000,
              interval: 4000,
              breakpoints: {
                700: {
                  drag: true,
                  autoplay: false,
                  pagination: "false",
                  perPage: 1,
                  perMove: 1,
                  gap: "2em",
                  padding: "0em",
                  arrows: false,
                  pauseOnHover: false,
                  resetProgress: false,
                },
              },
            }}
          >
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “DYNEM lieferte nicht nur Komponenten – sie verstanden
                      unsere Produktvision und halfen uns, sie umzusetzen. Ihr
                      Team fühlt sich wie eine Erweiterung unseres Teams an.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– Head of Product, E-Bike-Startup</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Wir haben die Produktion reibungslos von 500 auf 5.000
                      Einheiten pro Monat gesteigert. Die gleichbleibende
                      Qualität und Termintreue von DYNEM hat entscheidend dazu
                      beigetragen.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– COO, südostasiatische Mobilitätsmarke</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Dank der Antidumping-konformen Exporte von DYNEM konnten
                      wir den EU-Markt mit massiven Zoll Einsparungen
                      erschließen – fast 87 % weniger Kosten.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Direktor für internationalen Handel, US-Einzelhändler
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Die Flexibilität, unsere E-Faltbike-Linie individuell
                      anzupassen, war wirklich beeindruckend. DYNEM gab uns die
                      Freiheit, ein Produkt zu entwickeln, das unsere Marke
                      widerspiegelt.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– Produktmanager, Urban Mobility Brand</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Sie produzieren nicht nur – sie lösen Probleme. DYNEM hat
                      uns geholfen, wichtige Teile neu zu gestalten, was unsere
                      Fahrleistung tatsächlich verbessert hat.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>– F&E-Leiter, Premium-E-Bike-Label</small>
                  </div>
                </div>
              </div>
            </SplideSlide>
            <SplideSlide>
              <div className="p-2">
                <div
                  className="d-flex justify-content-center align-items-center p-3 rounded-3"
                  style={{
                    flexDirection: "column",
                    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
                  }}
                >
                  <div className="mb-3">
                    <Icon
                      icon="iconoir:profile-circle"
                      width="80"
                      height="80"
                    />
                  </div>
                  <div>
                    <small>
                      “Globale Beschaffung war immer eine Herausforderung, bis
                      wir DYNEM fanden. Ihre Lieferketten Zuverlässigkeit und
                      Exportdokumentation sind erstklassig.”
                    </small>
                  </div>
                  <div
                    className="poppins-medium mt-2"
                    style={{ fontSize: "0.85em" }}
                  >
                    <small>
                      – Einkaufsleiter, Vertriebspartner im Nahen Osten
                    </small>
                  </div>
                </div>
              </div>
            </SplideSlide>
          </Splide>
        </div>
        {/* news */}
        <div className="news">
          <div className="container mt-5 py-4 py-lg-5">
            <h2 className="poppins-bold text-uppercase mb-3 mb-lg-5">
              In den Nachrichten
            </h2>
            <Splide
              className="mb-2 mb-lg-0 p-0 align-items-center"
              options={{
                arrows: false,
                drag: false,
                type: "slide",
                pagination: false,
                autoplay: false,
                perMove: 1,
                gap: "1em",
                padding: "0em",
                pauseOnHover: true,
                resetProgress: false,
                perPage: 4,
                speed: 1000,
                interval: 3000,
                breakpoints: {
                  700: {
                    drag: true,
                    perPage: 1.3,
                    arrows: false,
                    perMove: 1,
                    gap: "1em",
                    padding: "0em",
                    pauseOnHover: false,
                    resetProgress: false,
                    focus: 0,
                    start: 0,
                    speed: 1000,
                    interval: 3000,
                  },
                },
              }}
              muted={true}
            >
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+1.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/kxan.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM begins construction of World's Biggest Integrated
                    Electric Cycle Gigafactory.....
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.kxan.com/business/press-releases/cision/20240509IO08933/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india/"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/ktla.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    India’s DYNEM to Establish World’s Largest Integrated E-Bike
                    Gigafactory
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://fox59.com/business/press-releases/cision/20240509IO08933/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india/"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/benzinga.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM Breaks Ground on World’s Largest Integrated Electric
                    Cycle Gigafactory ...
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.benzinga.com/pressreleases/24/05/n38730936/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
              <SplideSlide className="h-100">
                <div className="p-3" style={{ backgroundColor: "white" }}>
                  <div>
                    <img
                      src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+4.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/fox8.png"
                    className="img-fluid mt-2"
                  ></img>
                  <p className="my-3 news-heading poppins-medium">
                    DYNEM Strengthens India’s Manufacturing Prowess: World’s
                    Biggest .....
                  </p>
                  <small>May 09, 2024</small>
                  <div
                    className="w-100 text-center py-2 mt-2"
                    style={{
                      backgroundColor: "black",
                      minHeight: "max-content",
                    }}
                  >
                    <a
                      className="text-light text-decoration-none"
                      href="https://www.benzinga.com/pressreleases/24/05/n38730936/dynem-begins-construction-of-worlds-biggest-integrated-electric-cycle-gigafactory-in-india"
                    >
                      Read More
                    </a>
                  </div>
                </div>
              </SplideSlide>
            </Splide>
            <div className="mt-5 pt-lg-4">
              <h2 className="poppins-medium mb-3 mb-lg-4 container">
                Certifications
              </h2>
              <div className="container pb-4">
                <img
                  src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/certifications__png.png"
                  alt="certifications"
                  className="w-100"
                ></img>
              </div>
            </div>
          </div>
        </div>
        {/* FAQs */}
        <div className="container mt-5 pt-lg-5">
          <div className="d-flex faq-landing">
            <div className="faq-landing-1">
              <h2 className="poppins-medium mb-2 mb-lg-4">
                Häufig gestellte Fragen
              </h2>
              <p className="mb-lg-5">
                Haben Sie Fragen? Wir haben bereits Antworten. Es ist, als
                könnten wir Sie denken hören.
              </p>
              <div className="d-lg-block d-none">
                <h4 className="poppins-medium mb-2">
                  Haben wir etwas verpasst?
                </h4>
                <p className="mb-lg-5">
                  Vereinbaren Sie ein persönliches Gespräch mit unseren
                  Experten.
                </p>
                <div className="req-call my-5 my-lg-0">
                  <a
                    href="tel:+918956703515"
                    className="btn btn-dark px-5 d-flex justify-content-between rounded-0"
                    style={{ width: "fit-content" }}
                  >
                    Fordern Sie einen Anruf an
                  </a>
                </div>
              </div>
            </div>
            <div className="accordion faq-landing-2" id="accordionExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Was unterscheidet DYNEM von anderen E-Bike-Herstellern?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body poppins-thin">
                    <p>
                      DYNEM zeichnet sich durch innovative Innovationen,
                      umweltfreundliche Praktiken und umfangreiche
                      Anpassungsmöglichkeiten aus. Unsere hochmoderne
                      Gigafactory, globale Compliance und unser Expertenteam
                      sorgen für erstklassige Qualität und nahtlosen Support von
                      der Produktion bis zum After-Sales, sodass Sie sich rundum
                      beruhigt zurücklehnen können.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    Kann ich mein E-Bike mit DYNEM individualisieren?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      Absolut! DYNEM bietet umfangreiche
                      Individualisierungsmöglichkeiten, sodass Sie Ihr E-Bike an
                      Ihren spezifischen Stil und Ihre Bedürfnisse anpassen
                      können. Mit unserem OEM-Service können Sie Branding,
                      Spezifikationen und Funktionen an Ihre Vorlieben anpassen.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    Wie viele E-Bikes produziert DYNEM jährlich?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      DYNEM verfügt über die Kapazität, jährlich 500.000 E-Bikes
                      zu produzieren und anzupassen. Unsere effizienten
                      Produktionsprozesse und erstklassige Infrastruktur
                      ermöglichen es uns, der wachsenden globalen Nachfrage
                      gerecht zu werden.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    Welche Vorteile bieten die Antidumping-Lösungen von DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      Mit den legalen Antidumping-Lösungen von DYNEM können
                      Importeure bis zu 87 % Steuern sparen. Unsere Produkte
                      entsprechen den globalen Vorschriften und gewährleisten
                      gleiche Wettbewerbsbedingungen ohne Antidumpingsteuern.
                      Dies macht DYNEM zu einer kostengünstigen und konformen
                      Wahl für Importeure weltweit.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingfive">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    Wie unterstützt DYNEM Nachhaltigkeit?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      DYNEM setzt sich für Nachhaltigkeit durch
                      umweltfreundliche Praktiken und innovative Technologie
                      ein. Unsere E-Bikes sind darauf ausgelegt, den
                      CO2-Fußabdruck zu reduzieren und eine grünere Zukunft zu
                      fördern, ganz im Einklang mit unserer Vision einer
                      nachhaltigen Mobilität.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingSix">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseSix"
                    aria-expanded="false"
                    aria-controls="collapseSix"
                  >
                    Welche Art von After-Sales-Support bietet DYNEM?
                  </button>
                </h2>
                <div
                  id="collapseSix"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingSix"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <p>
                      <Link
                        to={"/"}
                        style={{ color: "inherit", cursor: "auto" }}
                        className="text-decoration-none"
                      >
                        DYNEM
                      </Link>{" "}
                      legt großen Wert auf die Kundenzufriedenheit mit
                      engagiertem After-Sales-Support. Vom ersten Kauf bis zur
                      langfristigen Wartung ist unser Team bestrebt, nahtlose
                      und zuverlässige Unterstützung zu leisten und unseren
                      Kunden ein reibungsloses und zufriedenstellendes Erlebnis
                      zu gewährleisten.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-lg-none text-center mt-3">
              <h4 className="poppins-medium mb-2">Haben wir etwas verpasst?</h4>
              <p className="mb-lg-5">
                Vereinbaren Sie ein persönliches Gespräch mit unseren Experten.
              </p>
              <div className="req-call my-4">
                <a
                  href="tel:+918956703515"
                  className="btn btn-dark px-5 d-flex justify-content-between rounded-0"
                  style={{ width: "fit-content" }}
                >
                  Fordern Sie einen Anruf an
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="d-lg-block d-none">
          <div className="d-flex justify-content-center align-items-center mt-4 mt-lg-5">
            <Modal className="primary-button fw-bold px-4 py-2 rounded-5" />
          </div>
        </div>
        <div className="d-lg-none">
          <div className="d-flex justify-content-center align-items-center mt-4 mt-lg-5">
            <ModalMobile className="primary-button fw-bold px-4 py-2 rounded-5" />
          </div>
        </div>
        {/* contact us */}
        <div className="mt-5 py-lg-5" style={{ backgroundColor: "black" }}>
          <div className="container py-lg-5 py-4">
            <div className="d-flex mb-3 mb-lg-0" style={{ gap: "4em" }}>
              <div className="d-none d-lg-block w-50">
                <div className="row">
                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-end">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                        className="w-75 p-3"
                      ></img>
                    </div>
                    <div className="d-flex justify-content-end">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                        className="w-100 p-3"
                      ></img>
                    </div>
                  </div>
                  <div className="col-6 p-0">
                    <div className="d-flex justify-content-start mt-5">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid2.png"
                        className="w-100 p-3"
                      ></img>
                    </div>
                    <div className="d-flex justify-content-start">
                      <img
                        src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid4.png"
                        className="w-75 p-3"
                      ></img>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none d-lg-block">
                <h2 className="poppins-bold mb-4 text-light">
                  Lassen Sie uns verbinden
                </h2>
                <form className="contact-us-landing" onSubmit={submit}>
                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-100">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Name*
                      </label>
                      <input
                        type="text"
                        value={name}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                        required
                        class="form-control rounded-0"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>
                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div class="w-50">
                      <label
                        for="exampleInputPassword1"
                        class="form-label text-light"
                      >
                        Telefon*
                      </label>
                      <IntlTelInput
                        onChangeNumber={setPhoneNumber}
                        initOptions={{
                          initialCountry: "auto",
                          geoIpLookup: function (success, failure) {
                            fetch("https://ipapi.co/json")
                              .then((res) => res.json())
                              .then((data) => success(data.country_code))
                              .catch(() => failure());
                          },
                          strictMode: true,
                          separateDialCode: true,
                        }}
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        E-mail
                      </label>
                      <input
                        type="email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        required
                        class="form-control rounded-0"
                        aria-describedby="emailHelp"
                      />
                    </div>
                  </div>

                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1 text-light"
                        className="form-label text-light"
                      >
                        Unternehmen
                      </label>
                      <input
                        type="text"
                        value={companyName}
                        required
                        onChange={(e) => {
                          setCompanyName(e.target.value);
                        }}
                        class="form-control"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Product Portfolio*
                      </label>
                      <select
                        onChange={(e) => setProductPortfolio(e.target.value)}
                        class="form-select"
                        required
                        defaultValue=""
                        aria-label="Default select example"
                      >
                        <option value="" selected disabled></option>
                        <option value="E-Bikes">E-Bikes</option>
                        <option value="E-Scooters">E-Scooters</option>
                        <option value="Hyper-Bikes">Hyper-Bikes</option>
                        <option value="Moped">Moped</option>
                      </select>
                    </div>
                  </div>

                  <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Operational Countries*
                      </label>
                      <input
                        type="text"
                        value={country}
                        onChange={(e) => {
                          setCountry(e.target.value);
                        }}
                        class="form-control"
                        aria-describedby="emailHelp"
                      />
                    </div>
                    <div className="w-50">
                      <label
                        for="exampleInputEmail1"
                        className="form-label text-light"
                      >
                        Annual E-Bike Sales (units)
                      </label>
                      <select
                        onChange={(e) => setSales(e.target.value)}
                        class="form-select"
                        required
                        defaultValue=""
                        aria-label="Default select example"
                      >
                        <option value="" selected disabled></option>
                        <option value="less than 1000 units">
                          less than 1000 units
                        </option>
                        <option value="1000-5000 units">1000-5000 units</option>
                        <option value="5000-50,000 units">
                          5000-50,000 units
                        </option>
                        <option value="50,000+ units">50,000+ units</option>
                      </select>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Nachricht*
                    </label>
                    <textarea
                      class="form-control rounded-0"
                      required
                      id="exampleFormControlTextarea1"
                      rows="3"
                      value={enquiry}
                      onChange={(e) => {
                        setEnquiry(e.target.value);
                      }}
                    ></textarea>
                  </div>
                  <div className="mb-3 d-flex justify-content-center">
                    <ReCAPTCHA
                      sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                      onChange={(val) => setCapVal(val)}
                    ></ReCAPTCHA>
                  </div>
                  <button
                    disabled={!capVal}
                    type="submit"
                    class="btn btn-light w-100 poppins-medium rounded-0"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
            <div className="d-lg-none mb-5">
              <h2 className="poppins-bold mb-4 text-light">
                Lassen Sie uns verbinden
              </h2>
              <form className="contact-us-landing" onSubmit={submit}>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-100">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Name*
                    </label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>
                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div class="w-50">
                    <label
                      for="exampleInputPassword1"
                      class="form-label text-light"
                    >
                      Telefon*
                    </label>
                    <IntlTelInput
                      onChangeNumber={setPhoneNumber}
                      initOptions={{
                        initialCountry: "auto",
                        geoIpLookup: function (success, failure) {
                          fetch("https://ipapi.co/json")
                            .then((res) => res.json())
                            .then((data) => success(data.country_code))
                            .catch(() => failure());
                        },
                        strictMode: true,
                        separateDialCode: true,
                      }}
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      E-mail
                    </label>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      required
                      class="form-control rounded-0"
                      aria-describedby="emailHelp"
                    />
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Unternehmen
                    </label>
                    <input
                      type="text"
                      value={companyName}
                      required
                      onChange={(e) => {
                        setCompanyName(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Product Portfolio*
                    </label>
                    <select
                      onChange={(e) => setProductPortfolio(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="E-Bikes">E-Bikes</option>
                      <option value="E-Scooters">E-Scooters</option>
                      <option value="Hyper-Bikes">Hyper-Bikes</option>
                      <option value="Moped">Moped</option>
                    </select>
                  </div>
                </div>

                <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Operational Countries*
                    </label>
                    <input
                      type="text"
                      value={country}
                      onChange={(e) => {
                        setCountry(e.target.value);
                      }}
                      class="form-control"
                      aria-describedby="emailHelp"
                    />
                  </div>
                  <div className="w-50">
                    <label
                      for="exampleInputEmail1"
                      className="form-label text-light"
                    >
                      Annual E-Bike Sales (units)
                    </label>
                    <select
                      onChange={(e) => setSales(e.target.value)}
                      class="form-select"
                      required
                      defaultValue=""
                      aria-label="Default select example"
                    >
                      <option value="" selected disabled></option>
                      <option value="less than 1000 units">
                        less than 1000 units
                      </option>
                      <option value="1000-5000 units">1000-5000 units</option>
                      <option value="5000-50,000 units">
                        5000-50,000 units
                      </option>
                      <option value="50,000+ units">50,000+ units</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label
                    for="exampleInputEmail1"
                    className="form-label text-light"
                  >
                    Nachricht*
                  </label>
                  <textarea
                    class="form-control rounded-0"
                    id="exampleFormControlTextarea1"
                    required
                    rows="3"
                    value={enquiry}
                    onChange={(e) => {
                      setEnquiry(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="mb-3 d-flex justify-content-center">
                  <ReCAPTCHA
                    sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                    onChange={(val) => setCapVal(val)}
                  ></ReCAPTCHA>
                </div>
                <button
                  disabled={!capVal}
                  type="submit"
                  class="btn btn-light w-100 poppins-medium rounded-0"
                >
                  Submit
                </button>
              </form>
            </div>
            <div className="row p-2 d-lg-none">
              <div className="col-6 p-0">
                <div className="d-flex justify-content-end">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+3.png"
                    className="w-75 p-2"
                  ></img>
                </div>
                <div className="d-flex justify-content-end">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/News+2.png"
                    className="w-100 p-2"
                  ></img>
                </div>
              </div>
              <div className="col-6 p-0">
                <div className="d-flex justify-content-start mt-5">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid2.png"
                    className="w-100 p-2"
                  ></img>
                </div>
                <div className="d-flex justify-content-start">
                  <img
                    src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landingPages/get-quote/grid4.png"
                    className="w-75 p-2"
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandingPage2De;
